
let cookie={
    //获取cookie
    getCookie:(name)=> {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return (arr[2]);
        else
            return null;
    },
    //设置cookie  以分钟为单位
    setCookie: (c_name, value, minute) =>{
        var exdate = new Date();
        exdate.setTime(exdate.getTime() + minute*60*1000);
        document.cookie = c_name + "=" + escape(value) + ((minute == null) ? "" : ";expires=" + exdate.toGMTString());
    },
    //删除cookie
    delCookie: function(name){
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
}

export default cookie;



// WEBPACK FOOTER //
// ./src/utils/cookie.js